import { useEffect } from "react";

/** Hook to prevent the browser tab from closing if there is an ongoing attempt. */
export function useReloadProtection(shouldPreventReload: boolean) {
  useEffect(() => {
    const preventUnload = (event: BeforeUnloadEvent) => {
      if (shouldPreventReload) {
        // Recommended
        event.preventDefault();

        // Included for legacy support, e.g. Chrome/Edge < 119
        event.returnValue = true;
      }
    };

    window.addEventListener("beforeunload", preventUnload);
    return () => window.removeEventListener("beforeunload", preventUnload);
  }, [shouldPreventReload]);
}
